import React from 'react';
import { Button } from 'framework7-react';
import PropTypes from 'prop-types';
import { getIcon } from '../helpers/utils';
import II18 from '../translate/II18';
import { connect } from 'react-redux';

class DoOnMobileButton extends React.Component {
  render = () => {
    const { onClick, embedMode } = this.props;

    return embedMode ? (
      <div></div>
    ) : (
      <Button
        style={{ width: 'fit-content', minWidth: 265 }}
        id={'doOnMobile'}
        color={'lightblue'}
        outline
        onClick={onClick}
      >
        {getIcon('material:phone_android', 20)}
        <II18 get={'continue_on_mobile'} />
      </Button>
    );
  };
}

DoOnMobileButton.propTypes = {
  onClick: PropTypes.func,
  embedMode: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    embedMode: state.embedMode
  };
}

export default connect(mapStateToProps)(DoOnMobileButton);
